import { render, staticRenderFns } from "./EditSupplier.vue?vue&type=template&id=134aa2dc&scoped=true"
import script from "./EditSupplier.vue?vue&type=script&lang=js"
export * from "./EditSupplier.vue?vue&type=script&lang=js"
import style0 from "./EditSupplier.vue?vue&type=style&index=0&id=134aa2dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134aa2dc",
  null
  
)

export default component.exports